import { useMutation, useQueryClient } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useUpdateSnippet = () => {
  const queryClient = useQueryClient();
  return useMutation(caseNestService.updateSnippet, {
    onMutate: async (updateSnippet) => {
      const queryKey = [queryKeys.snippets, updateSnippet?.caseTypeId];
      await queryClient.cancelQueries(queryKey);
      const snapshotOfPreviousSnippets = queryClient.getQueryData(queryKey);

      if (snapshotOfPreviousSnippets) {
        queryClient.setQueryData(queryKey, (oldSnippets) =>
          oldSnippets?.data?.map((oldSnippet) => {
            if (oldSnippet.id === updateSnippet.id) {
              return { ...oldSnippet, content: updateSnippet.content };
            }
          })
        );
      }
      return {
        snapshotOfPreviousSnippets,
      };
    },

    onError: (error, updateSnippet, { snapshotOfPreviousSnippets }) => {
      queryClient.setQueryData([queryKeys.snippets, updateSnippet?.caseTypeId], snapshotOfPreviousSnippets);
    },

    onSuccess() {
      queryClient.invalidateQueries(queryKeys.snippets);
    },
  });
};

export default useUpdateSnippet;
